// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";
// import dayjs from "dayjs";

// // Utility function to generate table headers
// const generateTableHeaders = (columns) => {
//   return columns
//     ?.map((col) => col.title)
//     .filter((header) => header !== "Actions" && header !== "Sl No");
// };

// // Utility function to generate table body rows
// const generateTableBody = (data, tableHeaders, fieldMapping) => {
//   return data?.map((item) => {
//     return tableHeaders?.map((header) => {
//       const field = fieldMapping[header];
//       let value = field?.includes(".")
//         ? field.split(".").reduce((obj, key) => obj && obj[key], item)
//         : item[field];

//       if (header.toLowerCase()?.includes("trnDate") && value) {
//         value = dayjs(value).format("DD-MM-YY");
//       }
//       if (field === "products") {
//         value = item?.product?.name;
//       }
//       if (field === "units") {
//         value = item?.unit?.name;
//       }
//       // if (field === "category") {
//       //   value = item?.category?.name;
//       // }
//       if (field === "type") {
//         switch (value) {
//           case 0:
//             value = "Stock Adjustment";
//             break;
//           case 1:
//             value = "Damage";
//             break;
//           case 2:
//             value = "Wastage";
//             break;
//           default:
//             value = "Unknown";
//         }
//       }
//       if (field === "active") {
//         value = item ? "Yes" : "No";
//       }

//       return value;
//     });
//   });
// };

// // const generateTableBody = (data, tableHeaders, fieldMapping, summaryRow,summaryRows) => {
// //   const typeLabels = {
// //     0: "Stock Adjustment",
// //     1: "Damage",
// //     2: "Wastage",
// //   };

// //   let tableData = data?.map((item) => {
// //     return tableHeaders?.map((header) => {
// //       const field = fieldMapping?.[header] ?? header.toLowerCase();
// //       let value = field?.includes(".")
// //         ? field.split(".").reduce((obj, key) => obj?.[key], item)
// //         : item?.[field];

// //       if (header.toLowerCase().includes("date") && value) {
// //         value = dayjs(value).format("DD-MM-YY");
// //       }
// //       if (field === "products") value = item?.product?.name;
// //       if (field === "units") value = item?.unit?.name;
// //       if (field === "type") value = typeLabels[value] ?? "Unknown";
// //       if (field === "active") value = value ? "Yes" : "No";

// //       return value ?? "";
// //     });
// //   });

// //   // Append Summary Row
// // //   if (summaryRow?.length) {
// // //     tableData.push(summaryRow);
// // //   }

// // //   return tableData;
// // // };

// // if (summaryRow?.length) {
// //   tableData.push(summaryRow);
// // }
// // if (summaryRows?.length) {
// //   tableData.push(summaryRows);
// // }

// // return tableData;
// // };


// // Excel Export
// export const exportMasterExcel = (getActiveTabData) => {
//   const { data, columns, fieldMapping,summaryRow,summaryRows,Rname} = getActiveTabData();
//   const tableHeaders = generateTableHeaders(columns);
//   const tableBody = generateTableBody(data, tableHeaders, fieldMapping,summaryRow,summaryRows );

//   const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...tableBody]);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

//   XLSX.writeFile(workbook, `${Rname}.xlsx`);
// };

// // Printable format
// export const printMasterReport = (getActiveTabData) => {
//   const { data, columns, fieldMapping ,summaryRow,summaryRows,Rname } = getActiveTabData();

//   const printWindow = window.open("", "_blank");

//   // Prepare the document for printing
//   printWindow.document.write("<html><head><title>Print Report</title>");
//   printWindow.document.write("<style>");
//   printWindow.document.write(`
//         table {
//             width: 100%;
//             border-collapse: collapse;
//         }
//         th, td {
//             border: 1px solid black;
//             padding: 8px;
//             text-align: left;
//         }
//         th {
//             background-color: #f2f2f2;
//         }
//     `);
//   printWindow.document.write("</style></head><body>");
//   printWindow.document.write(`<h1>${Rname}</h1>`);

//   const tableHeaders = generateTableHeaders(columns);
//   let tableHTML = "<table><thead><tr>";
//   tableHeaders.forEach((header) => {
//     tableHTML += `<th>${header}</th>`;
//   });
//   tableHTML += "</tr></thead><tbody>";

//   const tableBody = generateTableBody(data, tableHeaders, fieldMapping,summaryRow,summaryRows );
//   tableBody.forEach((row) => {
//     tableHTML += "<tr>";
//     row.forEach((cell) => {
//       tableHTML += `<td>${cell !== undefined ? cell : ""}</td>`;
//     });
//     tableHTML += "</tr>";
//   });
//   tableHTML += "</tbody></table>";

//   printWindow.document.write(tableHTML);
//   printWindow.document.write("</body></html>");

//   printWindow.document.close();
//   printWindow.print();
// };

// // PDF Export
// export const exportMasterPDF = (getActiveTabData) => {
//   const { data, columns, fieldMapping,summaryRow,summaryRows,Rname } = getActiveTabData();

//   // Set orientation based on the number of columns (e.g., more than 5 columns -> landscape)
//   const orientation = columns?.length > 9 ? "landscape" : "portrait";

//   // Initialize jsPDF with the dynamic orientation
//   const doc = new jsPDF({
//     orientation: orientation,
//   });

//   // Generate table headers and body
//   const tableHeaders = generateTableHeaders(columns);
//   const tableBody = generateTableBody(data, tableHeaders, fieldMapping,summaryRow,summaryRows );

//   // Use autoTable to export the table
//   autoTable(doc, {
//     head: [tableHeaders],
//     body: tableBody,
//   });

//   // Save the PDF
//   doc.save(`${Rname}.pdf`);
// };
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

// Utility function to generate table headers
const generateTableHeaders = (columns) => {
  return columns
    ?.map((col) => col.title)
    .filter((header) => header !== "Actions" && header !== "Sl No");
};

// Utility function to generate table body rows with decimal formatting
const generateTableBody = (data, tableHeaders, fieldMapping, currfmt, summaryRow, summaryRows) => {
  const tableData = data?.map((item) => {
    return tableHeaders?.map((header) => {
      const field = fieldMapping?.[header] ?? header.toLowerCase();
      let value = field?.includes(".")
        ? field.split(".").reduce((obj, key) => obj?.[key], item)
        : item?.[field];

      // Format Date Fields
      if (header.toLowerCase().includes("trndate") && value) {
        value = dayjs(value).format("DD-MM-YY");
      }

      // Map specific fields to readable names
      if (field === "products") value = item?.product?.name;
      if (field === "units") value = item?.unit?.name;
      if (field === "type") {
        value = { 0: "Stock Adjustment", 1: "Damage", 2: "Wastage" }[value] ?? "Unknown";
      }
      if (field === "active") value = value ? "Yes" : "No";

      // Format Numeric Values with currfmt
      if (typeof value === "number" && currfmt !== undefined) {
        value = value.toFixed(currfmt);
      }

      return value ?? "";
    });
  });

  // Append summary rows if available
  if (summaryRow?.length) tableData.push(summaryRow.map((val) => (typeof val === "number" ? val.toFixed(currfmt) : val)));
  if (summaryRows?.length) {
    summaryRows.forEach((row) => {
      tableData.push(row.map((val) => (typeof val === "number" ? val.toFixed(currfmt) : val)));
    });
  }

  return tableData;
};

// Export to Excel
export const exportMasterExcel = (getActiveTabData) => {
  const { data, columns, fieldMapping, currfmt, summaryRow, summaryRows, Rname } = getActiveTabData();
  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(data, tableHeaders, fieldMapping, currfmt, summaryRow, summaryRows);

  const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...tableBody]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  XLSX.writeFile(workbook, `${Rname}_${currfmt}.xlsx`);
};

// Print Report
export const printMasterReport = (getActiveTabData) => {
  const { data, columns, fieldMapping, currfmt, summaryRow, summaryRows, Rname } = getActiveTabData();
  const printWindow = window.open("", "_blank");

  printWindow.document.write("<html><head><title>Print Report</title>");
  printWindow.document.write("<style>");
  printWindow.document.write(`
        table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
        }
        th {
            background-color: #f2f2f2;
        }
    `);
  printWindow.document.write("</style></head><body>");
  printWindow.document.write(`<h1>${Rname} - Decimal Points: ${currfmt}</h1>`);

  const tableHeaders = generateTableHeaders(columns);
  let tableHTML = "<table><thead><tr>";
  tableHeaders.forEach((header) => (tableHTML += `<th>${header}</th>`));
  tableHTML += "</tr></thead><tbody>";

  const tableBody = generateTableBody(data, tableHeaders, fieldMapping, currfmt, summaryRow, summaryRows);
  tableBody.forEach((row) => {
    tableHTML += "<tr>";
    row.forEach((cell) => (tableHTML += `<td>${cell !== undefined ? cell : ""}</td>`));
    tableHTML += "</tr>";
  });

  tableHTML += "</tbody></table>";

  printWindow.document.write(tableHTML);
  printWindow.document.write("</body></html>");
  printWindow.document.close();
  printWindow.print();
};

// Export to PDF
export const exportMasterPDF = (getActiveTabData) => {
  const { data, columns, fieldMapping, currfmt, summaryRow, summaryRows, Rname } = getActiveTabData();

  const orientation = columns?.length > 9 ? "landscape" : "portrait";
  const doc = new jsPDF({ orientation });

  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(data, tableHeaders, fieldMapping, currfmt, summaryRow, summaryRows);

  autoTable(doc, {
    head: [tableHeaders],
    body: tableBody,
    theme: "grid",
  });

  doc.save(`${Rname}_${currfmt}.pdf`);
};
